import { render, staticRenderFns } from "./UserConferenceList.vue?vue&type=template&id=1bbbe2dc&scoped=true&"
import script from "./UserConferenceList.vue?vue&type=script&lang=js&"
export * from "./UserConferenceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbbe2dc",
  null
  
)

export default component.exports